import React from 'react';
import { FilterGroup, Switcher } from '@lt/components';
import { i18n } from '@lt/localization';
import type { IFilter } from '../types';

const FILTER_NAME = 'rating';
const FILTER_LABEL = i18n.t('filters.rating.title');

const FilterRating = ({
  data,
  className = '',
  isMobile = false,
  onChange,
  onClear,
}: IFilter): JSX.Element => {
  const handleChange = (clickedItem) => {
    const diff = data.map(({ id, selected }) => ({
      id,
      selected: id === clickedItem.id && !selected,
    }));

    onChange({ path: FILTER_NAME, diff });
  };

  const list = [
    ...(isMobile ? [] : [{ label: i18n.t('filters.rating.any'), id: 'ANY' }]),
    ...data.map((button) => ({ ...button, label: `${button.id}+` })),
  ];

  const isChanged = list.some((item) => item.selected);

  return (
    <FilterGroup
      className={className}
      label={FILTER_LABEL}
      isMobile={isMobile}
      showClearBtn={isChanged}
      onClear={() => onClear(FILTER_NAME)}
    >
      <Switcher
        name={FILTER_NAME}
        selectAllHandler={handleChange}
        list={list}
        order="asc"
        onChange={handleChange}
        isMobile={isMobile}
      />
    </FilterGroup>
  );
};

export default Object.assign(FilterRating, {
  filterName: FILTER_NAME,
  filterLabel: FILTER_LABEL,
  valuesLabel: (data) =>
    `${i18n.t('filters.rating.value')} ${
      data.find((item) => item.selected).id
    }`,
});
